import { render, staticRenderFns } from "./UpdateProductGeneralInfo.vue?vue&type=template&id=a578ba90&scoped=true"
import script from "./UpdateProductGeneralInfo.vue?vue&type=script&lang=js"
export * from "./UpdateProductGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateProductGeneralInfo.vue?vue&type=style&index=0&id=a578ba90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a578ba90",
  null
  
)

export default component.exports